module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100\">\n    <div class=\"padding__lr-5\" style=\"position: absolute; top: 0; left: 0; right: 0; bottom: 0\">\n        <div class=\"table wh100\">\n            <div>\n                <div class=\"valign-t\" style=\"width: 500px;\">\n                    <div name=\"page\" class=\"wh100 overflow-y__auto\"/>\n                    ")
    ;  if (widget.showEditControls && widget.canEdit()) { 
    ; __append("\n                    <div class=\"form__buttons padding__medium clearfix\">\n                        <div class=\"left\" name=\"view-buttons\">\n                            <div class=\"button\" title=\"Редактировать\" on-click=\"onEditClick\">Редактировать</div>\n                        </div>\n\n                        <div class=\"right\" name=\"editor-buttons\" style=\"display: none\">\n                            <div name=\"save\" class=\"button\" title=\"Сохранить\" on-click=\"onSaveClick\">Сохранить</div>\n                            <div name=\"cancel\" class=\"button\" title=\"Отмена\" on-click=\"onCancelClick\">Отмена</div>\n                        </div>\n                    </div>\n                    ")
    ;  } 
    ; __append("\n                </div>\n                <div class=\"valign-t relative\">\n                    <div name=\"map\" class=\"wh100\"/>\n                    <div name=\"draw-panel\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}